/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
    DocumentToJSONTyped,
} from './Document';

/**
 * Paginated list of documents.
 * @export
 * @interface ListDocumentsResponse
 */
export interface ListDocumentsResponse {
    /**
     * 
     * @type {Array<Document>}
     * @memberof ListDocumentsResponse
     */
    items: Array<Document>;
    /**
     * 
     * @type {number}
     * @memberof ListDocumentsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ListDocumentsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ListDocumentsResponse
     */
    limit: number;
}

/**
 * Check if a given object implements the ListDocumentsResponse interface.
 */
export function instanceOfListDocumentsResponse(value: object): value is ListDocumentsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function ListDocumentsResponseFromJSON(json: any): ListDocumentsResponse {
    return ListDocumentsResponseFromJSONTyped(json, false);
}

export function ListDocumentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDocumentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(DocumentFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
    };
}

export function ListDocumentsResponseToJSON(json: any): ListDocumentsResponse {
    return ListDocumentsResponseToJSONTyped(json, false);
}

export function ListDocumentsResponseToJSONTyped(value?: ListDocumentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(DocumentToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
    };
}

